import { Component, OnInit, EventEmitter, Output, Inject, Input } from '@angular/core';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NavigationExtras, Router } from '@angular/router';

interface Events {
  id: number;
}
@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {

  @Input() id: number;
  @Input() delete: boolean;
  @Input() package: boolean;
  public label: string;
  public altype: number = 1;
  // public altype1:number=;
  // public altype2:number=2;
  // public altype3:number=3;
  // public altype4:number=4;
  // public altype5:number=5;
  // public altype6:number=6;
  // public altype7:number=7;
  public deltype: string = "all";
  public name: any;
  public type: any;
  public uploadlist: any = { id: 0, name: "No File Selected", leads: 0 };
  public agents: any = [];
  confirmmsg: boolean = false;
  number: any;
  // AutoData:any=[];
  // Tagdata:any=[];
  // smsResponder:any=[];
  // answer:any=[];
  // matchData:any;
  // eventRec:any

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public dialogRef: MatDialogRef<AlertComponent>, protected router: Router) {
    this.delete = false;
    this.package = false;
  }

  ngOnInit() {
    console.log("FORM ALERT");
    // console.log(this.data);
    this.altype = this.data.type;
    console.log("altype", this.data.type);
    this.label = this.data.name;
    
    if (this.data.confir == "confirm") {
      this.confirmmsg = true
    }
    if (this.data.type) {
      this.number = this.data.type
      this.name = this.data.name
    }
  }

  onDelete(iddel: number) {
    console.log("Delete:");
    console.log("CAMPID:::" + this.data.name);
    this.dialogRef.close(iddel);
  }

  onBulkDelete(leads: any) {
    this.dialogRef.close(leads);
  }

  ChangeType(delevents: any) {
    console.log(delevents);
    this.deltype = delevents.value;
  }

  ChangeLeadList(leadlist: any) {
    console.log(leadlist);
    this.uploadlist = leadlist.value;
  }

  onBatchDelete() {
    this.dialogRef.close({ list: this.uploadlist, deltype: this.deltype, iduser: this.data.name.iduser });
  }

  onSelectuser(event: any, id: number) {
    console.log(event);
    console.log(id);
    if (event.checked)
      this.agents.push(id);
    else {
      for (let i = 0; i < this.agents.length; i++) {
        if (this.agents[i] == id)
          this.agents.splice(i, 1);
      }
    }
  }

  onphoneScriptsUpdate() {
    this.dialogRef.close({ agent: this.agents });
  }

  Close() {
    this.dialogRef.close(null);
  }

  confirmation() {
    this.dialogRef.close("yes");
  }
  navigate_SMTP(sp?:any) {

    let navigationExtras: NavigationExtras = {
      queryParams: {
        type: 2,
          sp:sp
        

      }
    };
    this.router.navigate(["/profile"], navigationExtras);

    this.dialogRef.close(null);
  }
}
